import styles from './index.module.sass';
import spicaSvg from '@/modules/mixing/images/spica.svg';
import { OfferDetails } from '@/modules/mixing/ts/buyers-prices.types';
import more from '@@/seller-account/components/buyer-details/images/more.svg';
import classNames from 'classnames';
import { Checkbox, Modal, Switch, Tooltip } from 'antd';
import { setOfferToEdit } from '@/modules/seller-account/store/offers.store';
import { useStore } from 'effector-react';
import { $singleBuyerData } from '@/modules/seller-account/store/buyers.store';
import { useEffect, useRef, useState } from 'react';
import infoSvg from '@@/mixing/images/info-icon.svg';
import { compareDateWithCurrentTime } from '../../helpers/compare-date.helper';
import { getOffsetMinutesToMoscow } from '../../helpers/get-offset-minutes-to-moscow.helper';
import { PURCHASE_PRICE_WITHOUT_VAT } from '@/shared/constants/price.constants';

export const Card = ({
  title,
  data,
  setShowOfferModal,
  editable,
  handleSwitch,
  handleDelete,
  handleSwitchPickup,
  hideSwitch,
  onExpiryAction,
}: ICard) => {
  const enabled = data?.enabled;
  const tooltipRef = useRef<any>(null);
  const buyerData = useStore($singleBuyerData);

  function calculateTimeDifferenceInMinutes(inputDate: string) {
    //const offsetMinutes = new Date().getTimezoneOffset();
    const currentDate: any = new Date();
    const targetDate: any = new Date(inputDate);
    if (isNaN(targetDate.getTime())) {
      return null;
    }

    if (targetDate.getTime() < currentDate.getTime()) {
      return null;
    } else {
      const timeDifference = targetDate - currentDate;
      const minutes = Math.floor(timeDifference / 60000);
      return minutes;
    }
  }

  const [timeLeft, setTimeLeft] = useState(
    compareDateWithCurrentTime(String(data.expiration_offer)),
  );
  const [minutesLeft, setMinutesLeft] = useState<number | null>(
    calculateTimeDifferenceInMinutes(data.expiration_offer as any),
  );
  const [displayTooltip, setDisplayTooltip] = useState(false);
  const [onExpiryCounter, setOnExpiryCounter] = useState(0);

  useEffect(() => {
    function handleClickOutside(event: any) {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
        setDisplayTooltip(false);
      }
    }
    document.addEventListener('click', handleClickOutside);

    // if (data.expiration_offer) {
    //   const minutesRemainder = calculateTimeDifferenceInMinutes(data.expiration_offer);
    //   if (!minutesRemainder) return;
    //   const intervalMs = minutesRemainder && minutesRemainder < 10 ? 1000 : 30000
    //   const offerExpirationReload = setInterval(
    //     () => setTimeLeft(compareDateWithCurrentTime(String(data.expiration_offer))),
    //     intervalMs,
    //   );
    //   return () => {
    //     clearInterval(offerExpirationReload);
    //   };
    // }

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (data.expiration_offer) {
      const overallTimeRemainder = compareDateWithCurrentTime(
        String(data.expiration_offer),
      );
      setTimeLeft(overallTimeRemainder);
      setMinutesLeft(calculateTimeDifferenceInMinutes(data.expiration_offer as any));
      const minutesRemainder = calculateTimeDifferenceInMinutes(data.expiration_offer);
      if (minutesRemainder === null || minutesRemainder < 0)
        return setTimeLeft(compareDateWithCurrentTime(String('0')));
      const intervalMs =
        minutesRemainder !== null && minutesRemainder < 10 ? 1000 : 30000;
      const offerExpirationReload = setInterval(() => {
        setTimeLeft(compareDateWithCurrentTime(String(data.expiration_offer)));
        setMinutesLeft(calculateTimeDifferenceInMinutes(data.expiration_offer as any));
        //clearInterval(offerExpirationReload)
      }, intervalMs);
      return () => {
        clearInterval(offerExpirationReload);
      };
    }
  }, [data]);

  useEffect(() => {
    onExpiryAction &&
      (async () => {
        if (minutesLeft && minutesLeft < 5) {
          if (data.id && onExpiryCounter === 0) {
            onExpiryAction(data.id);
            //setOnExpiryCounter(1);
          }
        }
      })();
  }, [minutesLeft, onExpiryCounter]);

  return (
    <div
      className={classNames(
        styles.card,
        minutesLeft !== null && minutesLeft >= 0 && minutesLeft < 5 && styles.warning,
        (minutesLeft === null || data.enabled === 0) && styles.expired,
      )}
    >
      <div className={styles.top__content}>
        <div className={styles.icon}>
          <img src={spicaSvg} alt="spica" />
        </div>
        <span>{title}</span>

        <div className={styles.controlPane}>
          {handleSwitch && !hideSwitch && (
            <Switch
              checked={enabled === 1 ? true : false}
              onClick={async (val) =>
                data.id && handleSwitch && (await handleSwitch(val, editable))
              }
            />
          )}
          {editable && (
            <img
              ref={tooltipRef}
              className={classNames(styles.more, displayTooltip && styles.more__active)}
              src={more}
              alt="more"
              onClick={() => setDisplayTooltip && setDisplayTooltip(!displayTooltip)}
            />
          )}
        </div>

        <div className={styles.tooltipParent}>
          <div
            className={classNames(
              styles.tooltip,
              displayTooltip && styles.tooltip__visible,
            )}
          >
            <span
              className={styles.edit}
              onClick={() => {
                setShowOfferModal(true);
                setOfferToEdit(data);
              }}
            >
              редактировать
            </span>
            <span
              className={styles.delete}
              onClick={() =>
                Modal.confirm({
                  title: 'Подтвердите действие',
                  content: 'Вы действительно хотите удалить предложение покупателя?',
                  okText: 'Да',
                  cancelText: 'Нет',
                  onOk: async () => {
                    await handleDelete();
                    setDisplayTooltip(false);
                  },
                })
              }
            >
              удалить
            </span>
          </div>
        </div>
      </div>
      <div className={styles.mid__content}>
        <div className={styles.specs__first}>
          <div className={styles.spec__item}>
            <span className={styles.spec__item_label}>год урожая</span>
            <span>{data.year}</span>
          </div>
          <div className={styles.spec__item}>
            <span className={styles.spec__item_label}>клейковина</span>
            <span>≥ {data.gluten}</span>
          </div>
          <div className={styles.spec__item}>
            <span className={styles.spec__item_label}>ИДК</span>
            <span>≤ {data.idk}</span>
          </div>
          <div className={styles.spec__item}>
            <span className={styles.spec__item_label}>клоп</span>
            <span>≤ {data.clop} </span>
          </div>
          <div className={styles.spec__item}>
            <span className={styles.spec__item_label}>протеин</span>
            <span>≥ {Number(data.protein).toFixed(2)}</span>
          </div>
          <div className={styles.spec__item}>
            <span className={styles.spec__item_label}>ЧП</span>
            <span>≥ {data.cp}</span>
          </div>
          <div className={styles.spec__item}>
            <span className={styles.spec__item_label}>натура</span>
            <span>≥ {data.nature} </span>
          </div>
          <div className={styles.spec__item}>
            <span className={styles.spec__item_label}>влажность</span>
            <span>
              ≤ {data.humidity} <span className={styles.spec__item_sign}>%</span>
            </span>
          </div>
          <div
            style={{ visibility: handleSwitch ? 'visible' : 'hidden' }}
            className={styles.takeAway}
          >
            <Tooltip title="стоимость логистики включена в стоимость предложения">
              <img className={styles.info} src={infoSvg} />
            </Tooltip>
            самовывоз покупателем со склада продавца:{' '}
            {data.pickup ? <b className={styles.on}>да</b> : <b>нет</b>}
          </div>
        </div>
        <div className={styles.specs__second}>
          <div className={styles.spec__item}>
            <span className={styles.spec__item_label}>сорная примесь</span>
            <span>
              ≤ {data.weed} <span className={styles.spec__item_label_child}>%</span>
            </span>
          </div>
          <div className={styles.spec__item}>
            <span className={styles.spec__item_label}>
              примесь других злаковых культур
            </span>
            <span>
              ≤ {data.admixture_other_cereals}{' '}
              <span className={styles.spec__item_label_child}>%</span>
            </span>
          </div>
          <div className={styles.spec__item}>
            <span className={styles.spec__item_label}>пшеница другого типа</span>
            <span>
              ≤ {data.wheat_different_type}{' '}
              <span className={styles.spec__item_label_child}>%</span>
            </span>
          </div>
        </div>
      </div>
      <div className={styles.bottom__content}>
        <div className={styles.bottom__deadline}>
          <span className={styles.label}>срок действия предложения</span>
          <span
            className={classNames(
              styles.deadline,
              minutesLeft !== null &&
                minutesLeft >= 0 &&
                minutesLeft < 5 &&
                data.enabled !== 0 &&
                styles.expirWarning,
            )}
          >
            {timeLeft}
          </span>
        </div>
        <div className={styles.bottom__price}>
          <span className={styles.spec__item_label}>{PURCHASE_PRICE_WITHOUT_VAT}</span>
          <span className={styles.total__price}>
            {data.price && +data.price > 0
              ? ` ${(+data.price).toLocaleString('RU-ru')} ₽/т`
              : 'по запросу'}
          </span>
        </div>
      </div>
    </div>
  );
};

interface ICard {
  title: string;
  data: OfferDetails;
  displayTooltip?: number;
  setDisplayTooltip?: (idx: number) => void;
  setShowOfferModal: (val: boolean) => void;
  editable: boolean;
  enabled: number;
  handleSwitch?: (val: boolean, editable: boolean) => Promise<void>;
  handleSwitchPickup?: (editable: boolean) => Promise<void>;
  handleDelete: () => Promise<void | unknown>;
  hideSwitch?: boolean;
  onExpiryAction?: (id: number) => Promise<void>;
}
